import { useUpdateMutationFactory, UseUpdateMutationProps } from '@/lib/react-query/update';
import { Inspection, InspectionLog, InspectionStepResult, ModelID } from '@/types';
import { post } from '@/utils/api';
import { featureKeys, featurePath } from '.';

export type RecordInspectionStepDTO = {
  inspection: Inspection;
  log: InspectionLog;
  inspection_step_id: ModelID;
} & {
  data: {
    status?: InspectionStepResult['status'];
    notes?: string;
    uploads?: File[];
  };
};

const recordInspectionStep = ({
  inspection,
  log,
  inspection_step_id,
  data,
}: RecordInspectionStepDTO) =>
  post<InspectionLog>(
    `${featurePath(inspection)}/${log.id}/steps/${inspection_step_id}`,
    data,
    {},
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );

export const useRecordInspectionStep = (options?: UseUpdateMutationProps<InspectionLog>) => {
  return useUpdateMutationFactory({
    invalidateKeys: featureKeys,
    mutationFn: recordInspectionStep,
    ...options,
  });
};
